import React from 'react';

const PhoneMockup = ({ placeholder, imageUrl, className = '' }) => {
  return (
    <div className={`relative ${className}`}>
      {/* Phone frame */}
      <div className="relative w-64 h-[520px] bg-gray-900 rounded-[3rem] shadow-2xl border-8 border-gray-800 overflow-hidden">
        {/* Notch */}
        <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-40 h-7 bg-gray-900 rounded-b-3xl z-10"></div>
        
        {/* Screen */}
        <div className="absolute inset-2 bg-gradient-to-br from-blue-50 to-blue-100 rounded-[2.5rem] overflow-hidden flex items-center justify-center">
          {imageUrl ? (
            <img 
              src={imageUrl} 
              alt={placeholder}
              className="w-full h-full object-cover rounded-[2.5rem]"
            />
          ) : (
            <div className="text-center p-6">
              <div className="w-20 h-20 bg-gradient-to-br from-blue-400 to-blue-600 rounded-2xl mx-auto mb-4 flex items-center justify-center">
                <span className="text-white text-3xl font-bold">FL</span>
              </div>
              <p className="text-gray-700 font-medium text-sm">{placeholder}</p>
            </div>
          )}
        </div>
        
        {/* Home indicator */}
        <div className="absolute bottom-2 left-1/2 transform -translate-x-1/2 w-32 h-1.5 bg-gray-700 rounded-full"></div>
      </div>
    </div>
  );
};

export default PhoneMockup;